import React from 'react';
import { replaceThumbnails } from '../../thumbnail';
import Colors from './Colors';

class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    split(articles, type) {
        let lists = [];

        articles.map((v) => {
            let listType = v.science_index && v.science_index.split(';');
            if (type == 'Keywords') {
                listType = v.keywords;
            }

            if (listType) {
                listType.map((v2, i) => {
                    if (i < 5) {
                        lists.push(v2);
                    }
                });
            } else {
                lists = [];
            }
        });

        let set = new Set(lists);
        let list = [...set];
        list = list.filter((v) => v !== '');
        if (type == 'Keywords') {
            if (list[0] == '') {
                list = [];
            }
            return Colors({ list, type });
        } else
            return list
                .filter((v) => v !== '')
                .map((v, i) => <span key={i * 2}>{v}</span>);
    }

    replaceImg = (targetData) => {
        return replaceThumbnails[targetData.domain];
    };

    renderData() {
        return this.props.data.map((v, i) => {
            return (
                <div
                    key={i}
                    className="card-wrap"
                    onClick={() => {
                        this.props.resultDetail.changePapers(v.taxa_id);
                        this.props.clickDetail();
                    }}
                >
                    {v.img && (
                        <div
                            className="thumb"
                            style={{ backgroundImage: `url(${v.img}), url(${this.replaceImg(v)})` }}
                        />
                    )}
                    <div className="card-text">
                        <div className="name-wrap">
                            <p className="common-name">{v.cname}</p>
                            <p className="scientific-name">
                                {v.sname} <span>({v.domain})</span>
                            </p>
                        </div>
                        <div className="keywords">
                            {this.split(v.articles, 'Keywords')}
                        </div>
                        <div className="index-wrap">
                            {this.split(v.articles)}
                        </div>
                    </div>
                </div>
            );
        });
    }

    render() {
        return this.renderData();
    }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/searchResult/Card.jsx